import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { stripSensitiveQueryParams } from 'src/app/shared/common/strip-sensitive-query-params.util';
import { Location, DatePipe, NgIf, NgFor } from '@angular/common';
import {
  BehaviorSubject,
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  forkJoin,
  map,
  Observable,
  of,
  startWith,
  Subject,
  takeUntil,
} from 'rxjs';
import { ApiResponse } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { Branch } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import {
  Department,
  Designation,
} from 'src/app/models/interface/CAM/TravellerInterface';
import { AccountService } from 'src/app/services/accountService/account.service';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ContentService } from '../../../cam/services/content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { SignUpContentServiceService } from 'src/app/modules/registration/services/sign-up-content-service.service';
import { jwtDecode } from 'jwt-decode';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { StateGroup } from 'src/app/models/interface/cam.interface';
import { RegistationUtilitiesService } from '../../services/registation-utilities.service';
import { MatDialog } from '@angular/material/dialog';
import { LinkAccountDialogComponent } from '../../components/link-account-dialog/link-account-dialog.component';
import { AuthServiceService } from 'src/app/services/authService/auth-service.service';
import { ThankyouService } from 'src/app/shared/common/thankyou.service';
import { environment } from 'src/environments/environment';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { ExpiryDateComponent } from '../../../cam/components/expiry-date/expiry-date.component';
import { DateOfBirthCalendarComponent } from '../../components/date-of-birth-calendar/date-of-birth-calendar.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DependentDatalayerService } from 'src/app/services/dataLayer/CAM/dependent.service';
import { WaitingComponent } from 'src/app/shared/components/waiting/waiting.component';

@Component({
  selector: 'app-dependent-onboard',
  templateUrl: './dependent-onboard.component.html',
  styleUrl: './dependent-onboard.component.scss',
  imports: [ReactiveFormsModule, FormsModule, NgSelectComponent, AutoBlurSelectDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgIf, NgLabelTemplateDirective, NgNotFoundTemplateDirective, MatError, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, ExpiryDateComponent, DateOfBirthCalendarComponent, MatSelect, NgFor, MatOption, MatRadioGroup, MatRadioButton, MatSlideToggle, MatCheckbox, MatButton, MatProgressSpinner, DatePipe, WaitingComponent]
})
export class DependentOnboardComponent implements OnInit, OnDestroy {
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  dependentForm!: FormGroup;
  editMode: boolean = false;
  newCustomCountries: any[] = [];
  countriesLists: any[] = [];
  filteredCountries: any;
  stateGroupOptions: Observable<StateGroup[]> = new BehaviorSubject<
    StateGroup[]
  >([]).asObservable();
  NationalityOptions: Observable<StateGroup[]> = new BehaviorSubject<
    StateGroup[]
  >([]).asObservable();
  PreviousCountryCode: any;
  elmVerified: boolean = false;
  selectedExpiryDate: Date | null = null;
  branchList: Branch[] = [];
  departmentLIst: any[] = [];
  designationList: any[] = [];
  CommonObj = {
    docType: '',
    docName: '',
  };
  relationshipList: string[] = ['Child', 'Spouse', 'Sibling', 'Parent'];
  isChildVisible: { [key: string]: boolean } = {
    isDOBCalendarVisible: false,
    isExpiaryCalendarVisible: false,
  };
  token: any;
  alfursantoggle: boolean = false;
  private readonly destroy$ = new Subject<void>();
  content: any;
  onBoardContent: any;
  dependentData: any;
  dependentId: string = '';
  user: any;
  checkingELMAvailability: boolean = false;
  isLoadingSpinner: boolean = false;
  /** Full-page waiting until Sitecore + dependent token data are ready (email deep-link). */
  resultsLoaded: boolean = false;
  titles: any[] = [];
  private readonly childTitles = ['miss', 'mstr'];

  get filteredTitles(): any[] {
    if (!this.shouldShowChildTitlesOnly()) {
      return this.titles || [];
    }
    return (this.titles || []).filter((t: any) => {
      const phrase = String(t?.Phrase || '').replace(/\./g, '').trim().toLowerCase();
      return this.childTitles.includes(phrase);
    });
  }

  private shouldShowChildTitlesOnly(): boolean {
    const relationship = this.dependentForm?.get('relationship')?.value;
    if (relationship !== 'Child') {
      return false;
    }
    return this.isUnderTwoYears(this.dependentForm?.get('dateOfBirth')?.value);
  }

  private isUnderTwoYears(dobValue: string | null | undefined): boolean {
    if (!dobValue || typeof dobValue !== 'string') {
      return false;
    }
    const [day, month, year] = dobValue.split('/').map(Number);
    if (!day || !month || !year) {
      return false;
    }
    const dob = new Date(year, month - 1, day);
    if (isNaN(dob.getTime())) {
      return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const secondBirthday = new Date(dob);
    secondBirthday.setFullYear(dob.getFullYear() + 2);
    return today < secondBirthday;
  }

  private clearTitleIfNotAllowedForChild(): void {
    if (!this.shouldShowChildTitlesOnly()) {
      return;
    }
    const currentTitle = this.dependentForm.get('title')?.value;
    const normalized = String(currentTitle || '').replace(/\./g, '').trim().toLowerCase();
    if (currentTitle && !this.childTitles.includes(normalized)) {
      this.dependentForm.get('title')?.patchValue(null);
    }
  }

  constructor(
    private readonly fb: FormBuilder,
    public _CommonService: CommonService,
    public _ApiService: ApiService,
    private readonly _AccountService: AccountService,
    private readonly _camService: CamService,
    private readonly _ToastrApiService: ToastrApiService,
    private readonly contentService: ContentService,
    private readonly dictionaryContentService: DisctionaryContent,
    private readonly signUpContentService: SignUpContentServiceService,
    private readonly travelerManagement: TravelerManagement,
    private readonly _location: Location,
    private readonly route: ActivatedRoute,
    private readonly datePipe: DatePipe,
    private readonly _RegistationUtilitiesService: RegistationUtilitiesService,
    private readonly _MatDialog: MatDialog,
    private readonly authService: AuthServiceService,
    private readonly ThankyouService: ThankyouService,
    private readonly router: Router,
    private _DataLayer: DataLayerService,
    private readonly dependentGTMService: DependentDatalayerService,
  ) {
    this.contentService.loadContent();
    this.user = this.getUserFromToken();
    this.authService.getTokenbeforeLogin().subscribe((res: any) => {
      const tokenData = res.data;
      localStorage.setItem('token_type', tokenData.token_type);
      localStorage.setItem('access_token', tokenData.access_token);
      localStorage.setItem('expires_in', tokenData.expires_in);
      localStorage.setItem('session_id', tokenData.session_id);
      localStorage.setItem('scope', tokenData.scope);
    });
    this.dependentForm = this.fb.group({
      dependentId: [0],
      Nationality: [null, [Validators.required]],
      residence: [null, [Validators.required]],
      identityNumber: [
        null,
        [Validators.required, Validators.minLength(6), Validators.maxLength(10)],
      ],
      docExpiary: [null, [Validators.required]],
      issueCountry: [null],
      dateOfBirth: [null, [Validators.required]],
      title: [null, [Validators.required]],
      firstname: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(50),
        ],
      ],
      middleName: [null],
      lastname: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(50),
        ],
      ],
      gender: ['Male'],
      email: [
        '',
        [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/), Validators.maxLength(200)],
      ],
      countryCode: [null, [Validators.required]],
      mobileNumber: [ null, [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
      relationship: [null, [Validators.required]],
      alfursanOptIn: [],
      isAgreeTermsOfUse: [null, [Validators.required]],
      accessPersonalData: [null, [Validators.required]],
      accessOffersMarketingInfo: [],
      alfursanID: [''],
    });
    this.dependentForm.get('alfursanOptIn')?.valueChanges.subscribe((value: any) => {
      this.onToggleChange(value);
    })
    this.dependentForm
      .get('Nationality')
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.updateDocumentType(
          this.dependentForm.get('Nationality')?.value,
          this.dependentForm.get('residence')?.value
        );
        this.verifyELM('nn');
        this.validatePassportNumber();
      });

    this.dependentForm
      .get('residence')
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.updateDocumentType(
          this.dependentForm.get('Nationality')?.value,
          this.dependentForm.get('residence')?.value
        );
        console.log('residence changed ', this.dependentForm.get('residence')?.value);
        this.verifyELM('nn');
        this.validatePassportNumber();
      });
    this.dependentForm.get('title')?.valueChanges.subscribe((value: any) => {
      if (value == 'Ms' || value == 'Mrs') {
        this.dependentForm.get('gender')?.patchValue('Female');
      } else {
        this.dependentForm.get('gender')?.patchValue('Male');
      }
    });

    this.dependentForm.get('relationship')?.valueChanges.subscribe(() => {
      this.clearTitleIfNotAllowedForChild();
    });

    this.dependentForm.get('dateOfBirth')?.valueChanges.subscribe(() => {
      this.clearTitleIfNotAllowedForChild();
    });
  }

  ngOnInit(): void {
    combineLatest({
      content: this.contentService.content$,
      dictionary: this.dictionaryContentService.content$,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = {
          ...res.content,
          dictionary: res.dictionary,
        };
      });
    this.signUpContentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.onBoardContent = res;
        this.getSiteCoreArray('b2b.register.titledropdown')
      });

    // Email deep-link users never hit post-login Sitecore bootstrap — load here so labels/titles bind.
    forkJoin({
      manageTraveler: this.contentService.loadContent(),
      dictionary: this.dictionaryContentService.loadContent(),
      register: this.signUpContentService.contentLoad(),
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.loadDependentAfterContent(),
        error: () => this.loadDependentAfterContent(),
      });

    this._ApiService
      .getCountriesData()
      .then(($res) => {
        this.newCustomCountries =
          this._CommonService.groupCountriesFilter($res);
        this.groupCountries($res);
      })
      .catch(($err) => { });

    this.dependentForm
      .get('Nationality')
      ?.valueChanges.pipe(
        startWith(''),
        map((value) => this.filterCountries(value))
      )
      .subscribe((filteredCountries) => {
        this.filteredCountries = filteredCountries;
        this.groupCountries(this.filteredCountries);
      });
    window.scrollTo({ top: 0, behavior: 'smooth' });

    this.dependentForm.valueChanges.subscribe(() => {
      const nationality = this.dependentForm.get('Nationality')?.value;
      const residence = this.dependentForm.get('residence')?.value;
      const identityCtrl = this.dependentForm.get('identityNumber');

      if (!identityCtrl) return;

      if (nationality && residence) {
        // Passport only: same rules as new-traveler (required + 8–10 alphanumeric)
        if (nationality !== 'SA' && residence !== 'SA') {
          identityCtrl.setValidators([
            Validators.required,
            Validators.pattern(/^[a-zA-Z0-9]{6,12}$/),
          ]);
        } else {
          identityCtrl.setValidators([
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(10),
            this.customPassportValidator.bind(this)
          ]);
        }
      } else {
        identityCtrl.setValidators([
          Validators.minLength(6),
          Validators.maxLength(10),
          this.customPassportValidator.bind(this)
        ]);
        identityCtrl.setErrors(null);
      }

      identityCtrl.updateValueAndValidity({ emitEvent: false });
    });
    this.dependentForm.get('identityNumber')?.valueChanges.subscribe((val: any) => {
      console.log('identiy number change ', this.dependentForm.get('identityNumber')?.valid, !(this.CommonObj.docName != 'Passport'))
      if (this.dependentForm.get('identityNumber')?.valid && this.CommonObj.docName != 'Passport') {
        this.verifyELM('nn');
      }
    });
    // this.dependentForm.get('countryCode')?.valueChanges.subscribe((res: any) => {
    //   if (res) {
    //     this.updatePhoneNumberValidators();
    //   }
    // })
    const alfursan = this.dependentForm.get('alfursanID')?.value;
    this.dependentGTMService.dependentOnboarding('CompleteProfile_pageview', 'CTA', alfursan ? 'Alfursan_opted' : 'NA', alfursan);
  }

  /** Token + dependent API after Sitecore so titles/labels are available for patch. */
  private loadDependentAfterContent(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');
    // if (this.token) {
    //   stripSensitiveQueryParams(this.router, this.route, ['token']);
    // }
    setTimeout(() => {
      this.getDependentDetail();
    }, 500);
  }
  updatePhoneNumberValidators() {

    const phoneControl = this.dependentForm.get('mobileNumber');
    const selectedCountry = this.dependentForm.get('countryCode')?.value;
    const countryCode = selectedCountry;

    // Check if India (ISD code +91 or 91)
    const isIndia = countryCode === '+91' || countryCode === '91';

    if (isIndia) {
      // India: exactly 10 digits
      phoneControl?.setValidators([
        Validators.required,
        Validators.pattern(/^\d{10}$/),

      ]);
    } else {
      // Other countries: 6 to 12 digits
      phoneControl?.setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(12)
      ]);
    }

    phoneControl?.updateValueAndValidity();
  }
  private getUserFromToken() {
    const token = localStorage.getItem('QlAccessToken');
    if (!token) return null;

    const decoded: any = jwtDecode(token);
    return {
      subAgentId: decoded?.subAgentId,
      userId: sessionStorage.getItem('userId') || '',
      uid: decoded?.uid,
      role: decoded?.role
    };
  }
  getDependentDetail() {
    this._camService.getDependentByToken(this.token).subscribe((res: any) => {
      if (res?.data?.user_status != '2') {
        this.router.navigateByUrl('/linkExpired', { replaceUrl: true })
      } else {
        this.dependentData = res?.data;
        this.patchAllValue(res?.data);
        this.resultsLoaded = true;
      }
    }, (error: any) => {
      this.resultsLoaded = true;
      this._ToastrApiService.show('error', 'Something went wrong!');
    });
  }
  patchAllValue(data: any) {
    if (!data) return;
    const titlesList = Array.isArray(this.titles) ? this.titles : [];
    const matchedTitle = titlesList.find(
      (t: any) => t && t?.Phrase && data?.title && String(t.Phrase).replace(/\./g, '').trim().toLowerCase() === String(data.title).replace(/\./g, '').trim().toLowerCase()
    );
    this.dependentForm.patchValue({
      dependentId: data?.dependantId | 0,
      Nationality: data?.nationality || null,
      residence: data?.placeOfResidence || null,
      identityNumber: data?.documentNo || null,
      docExpiary: this.datePipe.transform(data?.documentExpiryDate, 'dd/MM/yyyy') || null,
      issueCountry: data?.documentIssuingCountry || null,
      dateOfBirth: this.datePipe.transform(data?.dob, 'dd/MM/yyyy') || null,
      title: matchedTitle?.Phrase || data?.title || null,
      firstname: data?.firstName || null,
      middleName: data?.middleName || null,
      lastname: data?.lastName || null,
      gender: data?.gender || '',
      email: data?.email || '',
      countryCode: data?.countryCode || null,
      mobileNumber: data?.phoneNo || null,
      relationship: data?.relation || null,
      alfursanOptIn: !!data?.alfursanId,
      alfursanID: data?.alfursanId || ''
    });
    this.updateDocumentType(data?.nationality, data?.placeOfResidence);
    if (this.dependentForm.get('identityNumber')?.value) {
      this.dependentForm.get('identityNumber')?.markAsTouched();
    }
    if (this.dependentForm.get('identityNumber')?.valid) {
      this.verifyELM('nn');
    }
  }
  groupCountries(data: any): void {
    if (!this.countriesLists?.length) {
      this.countriesLists = data;
    }
    this.filteredCountries = data;
    const grouped: {
      [key: string]: {
        name: string;
        code: string;
        isdCode: string;
        countryFlag: string;
      }[];
    } = this.filteredCountries?.reduce(
      (acc: any, country: any) => {
        const firstLetter = country.countryName[0].toUpperCase(); // Use countryName instead of Country
        if (!acc[firstLetter]) {
          acc[firstLetter] = [];
        }
        acc[firstLetter].push({
          name: country.countryName,
          code: country.isoCode,
          isdCode: country.code,
          countryFlag: country.newFlag.src,
        });
        return acc;
      },
      {} as {
        [key: string]: {
          name: string;
          code: string;
          isdCode: string;
          countryFlag: string;
        }[];
      }
    );
    if (this.filteredCountries) {
      const sortedGroupLetters = Object.keys(grouped).sort((a, b) =>
        a.localeCompare(b)
      );

      const saudiGroup = grouped['S']?.find((c) => c.name === 'Saudi Arabia');

      if (saudiGroup) {
        grouped['S'] = grouped['S'].filter((c) => c.name !== 'Saudi Arabia');
        grouped['S'] = [
          {
            name: 'Saudi Arabia',
            code: 'SA',
            isdCode: '+966',
            countryFlag:
              '/-/media/SaudiaWebApp/data/media/img/Flags/Latest-flags/Flag-saudi_arabia.ashx?rev=856c905ee3344e1295e5948ae4d64d9a',
          },
          ...grouped['S'],
        ];

        const index = sortedGroupLetters.indexOf('S');
        if (index > -1) {
          sortedGroupLetters.splice(index, 1);
        }
        sortedGroupLetters.unshift('S');
      }

      // Wrap the result in `of()` to make it an Observable
      this.stateGroupOptions = of(
        sortedGroupLetters.map((letter) => {
          return {
            letter: letter,
            names: grouped[letter],
          };
        })
      );
    }
  }

  getImageUrl(path: string): string {
    if (!path) return '';
    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');
    return `${base}/${cleanPath}`;
  }

  filterCountries(value: any): void {
    const searchField =
      value?.stateGroup?.split('+')?.length === 1
        ? 'countryName'
        : 'code';

    const searchValue = (value?.stateGroup || '')
      .replace('+', '')
      .toLowerCase();

    const currentState: any[] = this.countriesLists?.filter(
      ($country: any) =>
        $country[searchField]
          ?.toString()
          .toLowerCase()
          .includes(searchValue)
    );

    this.groupCountries(currentState);

    if (currentState?.length < 2) {
      this.PreviousCountryCode = currentState;
    }
  }

  convertToISODate(dob: string): string {
    if (!dob) return '';

    // Split the date into day, month, and year
    const dateParts = dob.split('/');

    // If the format is correct, return the date in the desired format (YYYY-MM-DD)
    if (dateParts.length === 3) {
      const day = dateParts[0];
      const month = dateParts[1];
      const year = dateParts[2];

      // Ensure the month and day are zero-padded to 2 digits
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    return dob; // If the format is incorrect, return the original string
  }

  private buildELMPayload(): any {
    const dob = this.dependentForm.get('dateOfBirth')?.value;
    const identity = this.dependentForm.get('identityNumber')?.value;
    const nationality = this.dependentForm.get('Nationality')?.value;

    if (!dob || !identity) return null;

    const formattedDob = this.convertToISODate(dob);

    switch (this.CommonObj.docType) {
      case 'nationalID':
        return {
          nationalID: identity,
          nationality: nationality,
          dateOfBirth: formattedDob,
        };

      case 'iqama':
        return {
          iqama: identity,
          dateOfBirth: formattedDob,
        };

      default:
        return null; // passport → no ELM call
    }
  }

  verifyELM(_: any): void {
    if (this.CommonObj.docType === 'passport' || this.CommonObj.docType == '') {
      this.dependentForm.get('firstname')?.enable();
      this.dependentForm.get('lastname')?.enable();
      return;
    }
    this.dependentForm.get('firstname')?.disable();
    this.dependentForm.get('lastname')?.disable();
    const payload = this.buildELMPayload();
    if (!payload) return;
    if (!this.dependentForm.get('identityNumber')?.valid) {
      return;
    }
    this.checkingELMAvailability = true;
    this._AccountService.VerifyELMV1(payload).subscribe(
      (response) => {
        if (response?.data?.firstName) {
          this.dependentForm.patchValue({
            firstname: response.data.firstName ? response.data.firstName : '',
            lastname: response.data.lastName ? response.data.lastName : '',
          });
          this.dependentForm.updateValueAndValidity();
        }
        this.elmVerified = true;
        this.dependentForm.get('identityNumber')?.setErrors(null);
        this.checkingELMAvailability = false;
      },
      (error) => {
        const ctrl = this.dependentForm.get('identityNumber');
        ctrl?.setErrors({
          ...(ctrl?.errors || {}),
          elmError: true,
        });
        this.dependentForm.patchValue({
          firstname: '',
          lastname: '',
        });
        this.checkingELMAvailability = false;
        this.dependentForm.updateValueAndValidity();
        ctrl?.markAsTouched();
      }
    );
  }

  updateDocumentType(nationality: string, residence: string): void {
    // let docList = this.content?.['b2b.managetraveler.nationalid'].split('/');
    let docList = ('National ID/ IQAMA/ Passport').split('/');
    if (!nationality || !residence) {
      this.CommonObj = { docType: '', docName: '' };
      return;
    }

    if (nationality === 'SA' && residence === 'SA') {
      this.CommonObj = {
        docType: 'nationalID',
        docName: docList[0],
      };
      if (this.dependentForm.get('identityNumber')?.valid) {
        this.verifyELM('nn');
      }
    }

    if (nationality === 'SA' && residence !== 'SA') {
      this.CommonObj = {
        docType: 'nationalID',
        docName: docList[0],
      };
      if (this.dependentForm.get('identityNumber')?.valid) {
        this.verifyELM('nn');
      }
    }
    if (nationality !== 'SA' && residence === 'SA') {
      this.CommonObj = {
        docType: 'iqama',
        docName: docList[1].trim(),
      };
      if (this.dependentForm.get('identityNumber')?.valid) {
        this.verifyELM('nn');
      }
    }

    if (nationality !== 'SA' && residence !== 'SA') {
      this.CommonObj = {
        docType: 'passport',
        docName: docList[2].trim(),
      };
      return;
    }
  }

  showComponent(componentKey: string, controlName?: string) {
    if (!Object.hasOwn(this.isChildVisible, componentKey)) {
      return;
    }
    Object.keys(this.isChildVisible).forEach((key) => {
      this.isChildVisible[key] = key === componentKey;
    });
  }
  onDateSelected2(
    event: { type: string; date: Date | null },
    key: string
  ): void {
    if (event.type === 'dob') {
      if (
        !event.date ||
        event.date.toDateString() === new Date(0).toDateString()
      ) {
        return;
      }
      this.selectedExpiryDate = event.date ? new Date(event.date) : null;
      const formattedDate = this.getFormattedDate(this.selectedExpiryDate);
      this.dependentForm.get('docExpiary')?.setValue(formattedDate);
      if (Object.hasOwn(this.isChildVisible, key)) {
        this.isChildVisible[key] = false;
      }
    }
  }
  getFormattedDate(date: Date | null): string | null {
    if (!date) return null;
    const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  onConfirm(componentKey: string) {
    this.verifyELM('nn');
    if (Object.hasOwn(this.isChildVisible, componentKey)) {
      this.isChildVisible[componentKey] = false;
    }
  }

  onDateSelected(event: any): void {
    if (event.isCalenderShow === true) {
      const date = event.date ? new Date(event.date) : null; // Ensure date is valid or null
      const dobDateControl = this.dependentForm.get('dateOfBirth');

      if (date) {
        // Format the date and set it in the form control
        const formattedDate = this.getFormattedDate(date);

        dobDateControl?.setValue(formattedDate); // Update the form control value
        dobDateControl?.clearValidators(); // Clear validators for a valid date
      } else {
        // Handle the case when the date is null
        dobDateControl?.setValue(null);
      }
      // Update form control validation status
      dobDateControl?.updateValueAndValidity();
      // Hide the DOB calendar
      this.isChildVisible['isDOBCalendarVisible'] = false;
    }
    this.verifyELM('nn');
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: Event) {
    const target = event?.target as HTMLElement;
    const isDobInput = target.getAttribute('formControlName');
    if (!isDobInput) {
      this.isChildVisible['isDOBCalendarVisible'] = false;
      this.isChildVisible['isExpiaryCalendarVisible'] = false;
    }
  }

  getBranchInfoList() {
    this._camService
      .GetBranchInformation()
      .then((res: ApiResponse<Branch[]>) => {
        if (res?.status == 'Success') {
          this.branchList = res.data;
        } else {
          this.branchList = [];
        }
      })
      .catch((err: any) => {
        const errMsg =
          'Something went wrong while fetching Branch Information List.';
        this._ToastrApiService.show('error', errMsg);
        console.error('Error fetching branch information:', err);
        this.branchList = []; // Reset tableData on error
      })
      .finally(() => { });
  }

  getDepartmentList() {
    this._camService
      .getDepartmentDetails()
      .then((res: ApiResponse<Department[]>) => {
        this.departmentLIst = res.data;
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => { });
  }

  getDesignation() {
    this._camService
      .getDesignationDetails()
      .then((res: ApiResponse<Designation[]>) => {
        if (res.status == 'Success') {
          this.designationList = res.data;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => { });
  }

  onSubmit(formData: any) {
    this.isLoadingSpinner = true;
    if (this.dependentForm.invalid) {
      this.isLoadingSpinner = false;
      return;
    }
    //gtm
    const alfursan = this.dependentForm.get('alfursanID')?.value;
    this.dependentGTMService.dependentOnboarding('Save', 'Save', alfursan ? 'Alfursan_opted' : 'NA', alfursan);

    const formValue = this.dependentForm.getRawValue();
    let payload = {
      b2bUserId: this.dependentData?.b2bUserId,
      b2bId: this.dependentData?.b2bId,
      dependantId: formValue?.dependentId,
      nationality: formValue?.Nationality,
      placeOfResidence: formValue?.residence,
      countryCode: formValue?.countryCode,
      title: formValue?.title,
      firstName: formValue?.firstname,
      middleName: formValue?.middleName,
      lastName: formValue?.lastname,
      relation: formValue?.relationship,
      email: formValue?.email,
      phoneNo: formValue?.mobileNumber,
      gender: formValue?.gender,
      documentNo: formValue?.identityNumber,
      dob: this._CommonService.formatDateToYMD(formValue?.dateOfBirth),
      alfursanId: formValue?.alfursanID,
      accessPersonalData: formValue?.accessPersonalData,
      accessOffersMarketingInfo: formValue?.accessOffersMarketingInfo,
      isAgreeTermsOfUse: formValue?.isAgreeTermsOfUse,
      documentIssuingCountry: formValue?.issueCountry,
      status: this.dependentData?.status,
      creatorId: this.dependentData?.creatorId,
      documentExpiryDate: this._CommonService.formatDateToYMD(formValue?.docExpiary),
      companyId: this.dependentData?.companyId
    };

    if (this.CommonObj.docName != 'Passport') {
      const FetchMatching = {
        // email: this.dependentForm.get('email')?.value,
        // mobile: `${formValue?.countryCode}${formValue?.mobileNumber}`,
        id: formValue?.identityNumber,
        IDtype: this.CommonObj.docType,
        nationality: formValue?.Nationality,
        // "fursanId": "FUR1234567"
      };

      const sessionID = localStorage.getItem('session_id');
      const token = localStorage.getItem('access_token');
      this._RegistationUtilitiesService
        .fetchMatching(sessionID, token, FetchMatching)
        .subscribe({
          next: (res: any) => {
            const hasMatch =
              Array.isArray(res?.data?.matchedContacts) &&
              res?.data?.matchedContacts.length > 0;
            // const hasMatch = 0 < 5;
            if (hasMatch) {
              this.isLoadingSpinner = false;
              this._MatDialog.open(LinkAccountDialogComponent, {
                data: {
                  matches: res.data, // Renamed for clarity
                  // matches: this.commonObj?.fakeRes,  // Renamed for clarity
                  elmStatus: this.elmVerified,
                  fullName: `${this.dependentForm.get('firstname')?.value} ${this.dependentForm.get('lastname')?.value}`,
                  data: payload,
                  idType: this.CommonObj.docType,
                  token: token,
                  sessionID: sessionID,
                  method: 'dependentMatch',
                  creatorId: payload?.creatorId,
                  ConsentTCPP: !!(
                    this.dependentForm.get('accessPersonalData')?.value &&
                    this.dependentForm.get('isAgreeTermsOfUse')?.value
                  ),
                  ConsentMarketing:
                    this.dependentForm.get('acceptPrivacy')?.value,
                  expiryDate: this.dependentForm.get('docExpiary')?.value,
                },
              });

            } else {
              this.onboard(payload)
            }
          },
          error: () => {
            this.isLoadingSpinner = false;
          },
        });

    } else {
      this.onboard(payload)
    }
  }
  onboard(payload: any) {
    this.isLoadingSpinner = true;
    this._camService
      .updateDependentProfile(payload)
      .then((res) => {
        if (!res) {
          this.isLoadingSpinner = false;
          this._ToastrApiService.show(
            'error',
            'No response received from server.'
          );
          return;
        }
        this.isLoadingSpinner = false;
        this.travelerManagement.dependent_addition_successAfteRes('Save', 'Success');
        this.dependentGTMService.addedSuccessfully('Email', 'You have been added as a family member.');
        this.ThankyouService.show({
          heading: 'You have been added as a family member.',
          description: this.dependentData?.creatorId == 0 ? '' : 'Your profile is now submitted for approval.',
          buttonText: 'Go To Login',
          isShowButton: false,
          redirectUrl: '',
        });
      })
      .catch((error) => {
        this.isLoadingSpinner = false;
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          'Something went wrong while saving the traveler. Please try again later.';
        this._ToastrApiService.show('error', errorMessage);
        if (error?.error?.errorCode == '401') {
          this._DataLayer.invite_link_error('Your link has expired', this.user?.role);
          this.router.navigate(['/linkExpired'], {
            queryParams: {
              userType: this.user?.role,
              token: this.token,   // 👈 IMPORTANT
              navigateFrom: 'CreateDepend'
            }
          });
        }
      });
  }

  onCancel() {
    const alfursan = this.dependentForm.get('alfursanID')?.value;
    this.travelerManagement.add_traveler_cancel_click();
    this.dependentGTMService.dependentOnboarding('Cancel', 'Cancel', alfursan ? 'Alfursan_opted' : 'NA', alfursan);
    // this.goToBack();
  }

  verifyDomainName() {
    const QlAccessToken: any = localStorage.getItem('QlAccessToken');
    const emailControl = this.dependentForm.get('email');

    if (!QlAccessToken || !emailControl?.value) return;

    const email: string = emailControl.value;
    const decoded: any = jwtDecode(QlAccessToken);

    if (decoded.hasDomain != 'false') {
      const afterAt = email.split('@')[1]; // part after @

      // 🔥 Compare domain
      if (afterAt.toLowerCase() !== decoded.domainName?.toLowerCase()) {
        // Set custom error
        emailControl.setErrors({
          ...(emailControl.errors || {}),
          domainMismatch: true,
        });
      } else {
        // Remove only domainMismatch error if exists
        if (emailControl.hasError('domainMismatch')) {
          const errors = { ...(emailControl.errors || {}) };
          delete errors['domainMismatch'];
          emailControl.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    }
  }

  getSiteCoreArray(keyString: string) {
    const data = this.onBoardContent?.[keyString];
    this.titles = Array.isArray(data) ? data : [];
    if (this.dependentData?.title) {
      const matchedTitle = this.titles.find(
        (t: any) => t && t?.Phrase && String(t.Phrase).replace(/\./g, '').trim().toLowerCase() === String(this.dependentData.title).replace(/\./g, '').trim().toLowerCase()
      );
      if (matchedTitle?.Phrase) {
        this.dependentForm.patchValue({ title: matchedTitle.Phrase });
      }
    }
  }
  goToBack() {
    this._location.back();
  }
  onToggleChange(isChecked: boolean) {
    const alFursanControl = this.dependentForm.get('alfursanID');

    const linkName = isChecked ? 'alfursan_toggle_on' : 'alfursan_toggle_off';
    const role = this.dependentData?.creatorId == 0 ? 'Admin' : this.dependentData?.creatorId == 1 ? 'Travel Arranger' : 'Employee';
    this.dependentGTMService.landingClick2(linkName, role);

    if (isChecked) {
      this.alfursantoggle = true;
      alFursanControl?.setValidators([Validators.required, alfursanValidator]);
    } else {
      this.alfursantoggle = false;
      alFursanControl?.clearValidators();
    }

    alFursanControl?.updateValueAndValidity();
  }
  blockInvalidCharacters1(event: KeyboardEvent): void {
    const invalidChars = [
      '<',
      '>',
      '"',
      "'",
      '`',
      ';',
      ':',
      '$',
      '|',
      '[',
      ']',
      '~',
      '--',
      '&',
      '@',
      '\\',
      '?',
      '+',
      '_',
      '#',
      '%',
      '^',
      '*',
      '!',
      '=',
      '%',
      '(',
      ')',
      '{',
      '}',
      '/',
      '.',
      ','
    ];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }
  ngOnDestroy() {
    this.editMode = false;
    this.destroy$.next();
    this.destroy$.complete();
  }
  trimField(field: string) {
    const control = this.dependentForm.get(field);
    if (control?.value) {
      control.setValue(control.value.trim());
    }
  }

  customPassportValidator(control: AbstractControl): ValidationErrors | null {
    if (this.CommonObj?.docType !== 'passport') return null;
    const passportNumber = control.value;
    if (!this.dependentForm) return null;
    const countryCode = this.dependentForm.get('Nationality')?.value;
    if (!passportNumber || !countryCode) return null;

    let isValid = true;
    switch (countryCode) {
      case 'IN':
        isValid = /^[A-Za-z]{1}[0-9]{7}$/.test(passportNumber);
        break;
      case 'SA':
        isValid = /^[A-Za-z]{1}[0-9]{7,9}$/.test(passportNumber);
        break;
      case 'UAE':
        isValid = /^[A-Za-z]{1}[0-9]{9}$/.test(passportNumber);
        break;
      case 'US':
        isValid = /^[a-zA-Z0-9]{9}$/.test(passportNumber);
        break;
      default:
        isValid = true;
    }

    if (!isValid) {
      return { invalidPassportNumber: true };
    }
    return null;
  }

  validatePassportNumber() {
    this.dependentForm.get('identityNumber')?.updateValueAndValidity();
  }

  get isSubmitDisabled(): boolean {
    const form = this.dependentForm;

    return (
      form.invalid ||
      !form.get('accessPersonalData')?.value ||
      !form.get('isAgreeTermsOfUse')?.value ||
      this.checkingELMAvailability ||
      !form.get('firstname')?.value?.trim() ||
      !form.get('lastname')?.value?.trim()
    );
  }
  onTermsChange(event: any, type: any) {
    console.log(type, 'type===')
    this.dependentGTMService.landingClick(`${type}_click`, event ? 'Checkbox Check' : 'Checkbox Uncheck');
  }
}
export function alfursanValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  if (!value) return null;

  const isNumber = /^\d+$/.test(value);
  const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);

  if (isNumber) {
    return value.length === 10 ? null : { invalidNumberLength: true };
  }

  if (isEmail) {
    return value.length <= 200 ? null : { emailMaxLength: true };
  }

  return { pattern: true };
}
